import type { Community, FormField, OnboardingFormConfig } from '@/types';

/** Membership states where we show only questions marked for pre-approval. */
export const PRE_APPROVAL_MEMBERSHIP_STATUSES = ['PENDING', 'INVITED'] as const;

export function isPreApprovalMembershipStatus(status: string): boolean {
  return (PRE_APPROVAL_MEMBERSHIP_STATUSES as readonly string[]).includes(status);
}

/** Pending/invited users only see fields with showForPending !== false (default: show). JOINED sees every field. */
export function fieldVisibleForMembershipStatus(
  field: FormField,
  membershipStatus: string
): boolean {
  if (!isPreApprovalMembershipStatus(membershipStatus)) return true;
  return field.showForPending !== false;
}

export function filterOnboardingFormForMembershipStatus(
  config: OnboardingFormConfig | null | undefined,
  membershipStatus: string
): OnboardingFormConfig | null {
  if (!config) return null;
  if (!isPreApprovalMembershipStatus(membershipStatus)) return config;

  const steps = (config.steps || [])
    .map((step) => ({
      ...step,
      fields: (step.fields || []).filter((field) =>
        fieldVisibleForMembershipStatus(field, membershipStatus)
      ),
    }))
    .filter((step) => step.fields.length > 0);

  return { steps };
}

/**
 * Guess membership outcome for the join / invite onboarding modal before the join request is sent.
 */
export function membershipStatusForJoinOnboardingPreview(community: Community): string {
  if (community.userStatus === 'INVITED') return 'INVITED';
  if (community.requiresApproval) return 'PENDING';
  return 'JOINED';
}
